import { FC, ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useDictionary } from '@cvt/hooks/useDictionary';


export const FAQList = () => {
  const dictionary = useDictionary();
  const { faq } = dictionary;

  return Object.keys(faq).map(key => {
    const questionGroup = faq[key as keyof typeof faq] as QuestionGroupProps;

    return <QuestionGroup key={key} {...questionGroup} />;
  });
};

type QuestionGroupProps = {
  label: string
  questions: [string, ReactNode][]
}

const QuestionGroup: FC<QuestionGroupProps> = ({ label, questions }) => {
  return (
    <Stack my={4}>
      <Typography variant="h6" color="primary" textTransform="uppercase" fontWeight={500}>
        {label}
      </Typography>
      <Box mt={1}>
        {questions.map(([question, answer], index) => (
          <Accordion key={index} disableGutters>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`question${index + 1}-content`}
              id={`question${index + 1}-header`}
            >
              <Typography component="span">{question}</Typography>
            </AccordionSummary>
            <AccordionDetails>{answer}</AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Stack>
  );
};
